import { useState } from "react";
import { BsSun, BsMoonStars } from "react-icons/bs";
import sound from "../assets/click.mp3";

const ToggleTheme = () => {
  const [theme, setTheme] = useState(localStorage.theme);

  const clickSound = new Audio(sound);

  const toggle = () => {
    setTheme((prev) => {
      const updatedTheme = prev === "dark" ? "light" : "dark";

      localStorage.theme = updatedTheme;
      localStorage.theme !== "dark"
        ? document.documentElement.classList.remove("dark")
        : document.documentElement.classList.add("dark");

      return updatedTheme;
    });
    clickSound.play();
  };

  return (
    <div
      className={`sm:order-2 dark:text-highlight cursor-pointer  ${
        theme === "dark" ? "animate-spin-slow" : "animate-pulse"
      }`}
      onClick={toggle}>
      {theme === "dark" ? <BsSun size={20} /> : <BsMoonStars size={20} />}
    </div>
  );
};

export default ToggleTheme;
